import React, { FC, useState } from 'react'

import { SupportApiCustomersWidget } from '../../../lib/support-api-customers-widget'
import {
    ApiCustomer,
    useApiCustomerCreateMutation,
    useApiCustomerGetAllQuery,
    useApiCustomerUpdateMutation,
} from '../../../common/redux/api/web-api'
import { CreateApiCustomersModal } from '../../../support/components/create-api-customer-modal/create-api-customer-modal'
import { notifyError, notifySuccess } from '../../../common/features/notificationsManager/Notify'
import { DeleteApiCustomerModal } from '../../../support/components/delete-api-customer-modal'
import MainPageLayout from '../../../ui/MainPage.layout'
import useText from '../../../common/hooks/useText'

export const ApiCustomersPage: FC = () => {
    const text = useText()
    const { data: apiCustomers = [], isFetching, refetch } = useApiCustomerGetAllQuery({})
    const [createApiCustomer] = useApiCustomerCreateMutation()
    const [updateApiCustomer] = useApiCustomerUpdateMutation()
    const [createApiCustomersModalIsOpened, setCreateApiCustomersModalIsOpened] = useState(false)
    const [removeApiCustomersModalIsOpened, setRemoveApiCustomersModalIsOpened] = useState(false)
    const [apiCustomer, setApiCustomer] = useState<ApiCustomer | undefined>(undefined)

    const handleCreateApiCustomer = async (apiCustomer: ApiCustomer) => {
        if (apiCustomer.id) {
            await updateApiCustomer({ apiCustomer })
                .unwrap()
                .then(() => {
                    setCreateApiCustomersModalIsOpened(false)
                    refetch()
                    notifySuccess(text('msgUpdateApiCustomerSuccess'))
                })
                .catch(() => {
                    notifyError(text('msgUpdateApiCustomerError'))
                })
        } else {
            await createApiCustomer({ apiCustomer })
                .unwrap()
                .then(() => {
                    setCreateApiCustomersModalIsOpened(false)
                    refetch()
                    notifySuccess(text('msgCreateApiCustomerSuccess'))
                })
                .catch(() => {
                    notifyError(text('msgCreateApiCustomerError'))
                })
        }
    }

    return (
        <MainPageLayout>
            <SupportApiCustomersWidget
                apiCustomers={apiCustomers}
                openApiCustomer={(ac) => {
                    setApiCustomer(ac)
                    setCreateApiCustomersModalIsOpened(true)
                }}
                deleteCustomer={(ac) => {
                    setApiCustomer(ac)
                    setRemoveApiCustomersModalIsOpened(true)
                }}
                isLoading={isFetching}
            />
            <CreateApiCustomersModal
                key={`create-modal-key-${createApiCustomersModalIsOpened}`}
                isOpened={createApiCustomersModalIsOpened}
                onCancel={() => {
                    setCreateApiCustomersModalIsOpened(false)
                    setApiCustomer(undefined)
                }}
                apiCustomer={apiCustomer}
                onCreate={handleCreateApiCustomer}
            />
            <DeleteApiCustomerModal
                key={`delete-modal-key-${removeApiCustomersModalIsOpened}`}
                isOpened={removeApiCustomersModalIsOpened}
                apiCustomer={apiCustomer ?? {}}
                onCancel={() => {
                    refetch()
                    setRemoveApiCustomersModalIsOpened(false)
                    setApiCustomer(undefined)
                }}
            />
        </MainPageLayout>
    )
}
